'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
const CANT_PARSE_LIBRARY_REQUEST = exports.CANT_PARSE_LIBRARY_REQUEST = 'Canʼt parse request to fetch library data';
const SERVICE_UNAVAILABLE = exports.SERVICE_UNAVAILABLE = 'Service unavailable';

// :: LibParams -> String
const cantFindLibVersion = exports.cantFindLibVersion = ({ owner, name, version }) => `${owner}/${name} has no version ${version}`;

const cantFindLibrary = exports.cantFindLibrary = ({ owner, name }) => `Library ${owner}/${name} not found`;


//////////////////
// WEBPACK FOOTER
// ../xod-pm/dist/messages.js
// module id = 575
// module chunks = 0